import React, { useContext, useMemo } from 'react';
import PageBookmarkBtn from 'components/PageBookmarkBtn/PageBookmarkBtn';
import { EditDishContext, IEditDishContext } from '../../editDishState/editDishContext';
import style from './ControlPanel.module.scss';

const EditDishControlPanel: React.FC = () => {
	const { changeVisibleForm, visibleForm, defaultCustomerLanguage, translations } =
		useContext<IEditDishContext>(EditDishContext);

	const hasTranslationError = useMemo(() => {
		if (!defaultCustomerLanguage) {
			return false;
		}
		const defaultNameTranslation = translations.find(
			(translation) => translation.languageId === defaultCustomerLanguage.id,
		)?.name;
		return !defaultNameTranslation;
	}, [defaultCustomerLanguage, translations]);

	return (
		<div className={style.container} data-test="EditDishControlPanel">
			<PageBookmarkBtn
				onClick={() => changeVisibleForm('mainForm')}
				isActive={visibleForm === 'mainForm'}
				btnName="mainInfoBookmark"
			/>
			<PageBookmarkBtn
				onClick={() => changeVisibleForm('translations')}
				isActive={visibleForm === 'translations'}
				btnName="translationsBookmark"
				isError={hasTranslationError}
			/>
		</div>
	);
};

export default EditDishControlPanel;
